import { render, staticRenderFns } from "./LabelRadio.vue?vue&type=template&id=0e75d510"
import script from "./LabelRadio.vue?vue&type=script&lang=js"
export * from "./LabelRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports